export default "__VITE_ASSET__CDeanoBL__"